// @flow

import * as React from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
// import { ReactForm, ReactFormField } from "@adrenalin/react-form";

import API from "../../api";
import LinkHandler from "../atoms/LinkHandler";
import TextButton from "../atoms/TextButton";
import Icon from "../atoms/Icon";

type PropsType = {
    className?: string,
    focusOnMount?: boolean,
    inline?: boolean,
    postType?: string,
    value?: string,
    defaultValue?: string,
    placeholder?: string,
    onResults?: Function,
    onSubmit?: Function,
    onClear?: Function,
};

const QuickSearch = (props: PropsType): React.Node => {
    const parentClass = "quick-search";
    const classes = [parentClass];
    const defaultResults = {
        search_result: [],
        related: [],
    };
    const inputRef = React.useRef(null);
    const history = useHistory();

    const [defaultValue, setDefaultValue] = React.useState(
        props.defaultValue || ""
    );
    const [query, setQuery] = React.useState(defaultValue || "");
    const [results, setResults] = React.useState(defaultResults);
    const [focused, setFocused] = React.useState(false);

    const handleSearchChange = e => {
        const searchValue = e.currentTarget.value;

        setQuery(searchValue);

        if (!searchValue) {
            setResults(defaultResults);
        }
    };

    const handleSubmit = e => {
        e.preventDefault();

        if (inputRef.current) {
            inputRef.current.blur();
        }

        if (props.onSubmit) {
            props.onSubmit(query);
        } else {
            history.push(`/search?q=${query}`);
            setQuery("");
        }
    };

    const handleCancelSearch = () => {
        if (inputRef.current) {
            inputRef.current.value = "";
        }
        setQuery("");
        setResults(defaultResults);
        setFocused(false);
    };

    const fetchSearchResults = () => {
        API.search({
            term: query,
            type: props.postType,
            perPage: 5,
            fullMode: false,
        }).then(({ data, headers }: { data: Array<any>, headers: Object }) => {
            setResults(data);

            if (props.onResults) {
                props.onResults();
            }
        });
    };

    const clearSearch = () => {
        setDefaultValue("");
        setQuery("");
        setResults("");
    };

    // on mount use effect
    React.useEffect(() => {
        if (props.focusOnMount && inputRef.current) {
            inputRef.current.focus();
        }
    }, []); // eslint-disable-line

    React.useEffect(() => {
        if (props.defaultValue && props.defaultValue !== defaultValue) {
            if (inputRef.current) {
                inputRef.current.value = props.defaultValue;
                setQuery(props.defaultValue);
            }
        }

        setDefaultValue(props.defaultValue || "");
    }, [props.defaultValue]); // eslint-disable-line

    // use effect for when new search query is typec
    React.useEffect(() => {
        const timeout = setTimeout(() => {
            if (query) {
                fetchSearchResults();
            }
        }, 300);

        return () => clearTimeout(timeout);
    }, [query]); // eslint-disable-line

    // use effect for new results
    React.useEffect(() => {
        if (results && results.search_result && results.search_result.length) {
            // show clear button

            if (props.onResults) {
                props.onResults(results);
            }
        } else {
            // hide clear button

            if (props.onClear) {
                props.onClear();
            }
        }
    }, [results]); // eslint-disable-line

    if (props.className) {
        classes.push(props.className);
    }

    if (props.inline) {
        classes.push(`${parentClass}--inline`);
    }

    if (focused) {
        classes.push(`${parentClass}--focused`);
    }

    return (
        <div className={classes.join(" ")}>
            <form className="quick-search__field" onSubmit={handleSubmit}>
                <button
                    type="submit"
                    class="quick-search__field__icon"
                    aria-label="Submit search"
                    value="Submit search"
                >
                    <Icon name="search" />
                </button>
                <input
                    ref={inputRef}
                    onChange={handleSearchChange}
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                    type="text"
                    name="search"
                    aria-label="Search"
                    placeholder={props.placeholder || "Search..."}
                    defaultValue={defaultValue}
                    required
                />
                <button
                    class="quick-search__field__reset"
                    onClick={clearSearch}
                    type="reset"
                >
                    <Icon name="close" />
                </button>
            </form>

            {(!props.inline &&
                results.search_result &&
                results.search_result.length) ||
            (query && props.inline) ? (
                <div className="quick-search__dropdown">
                    {results.search_result && results.search_result.length ? (
                        <ul className="quick-search__results">
                            {results.search_result
                                ? results.search_result.map(
                                      (result: { ID: any }, i) => {
                                          const resultItem =
                                              results.related && result.ID
                                                  ? results.related[result.ID]
                                                  : null;

                                          if (resultItem) {
                                              return (
                                                  <li key={i}>
                                                      <LinkHandler
                                                          to={resultItem.url}
                                                          onFocus={() =>
                                                              setFocused(true)
                                                          }
                                                          onBlur={() =>
                                                              setFocused(false)
                                                          }
                                                      >
                                                          {resultItem.title}
                                                      </LinkHandler>
                                                  </li>
                                              );
                                          } else {
                                              return null;
                                          }
                                      }
                                  )
                                : null}
                        </ul>
                    ) : null}
                    <TextButton
                        className="quick-search__clear"
                        onClick={handleCancelSearch}
                        onFocus={() => setFocused(true)}
                        onBlur={() => setFocused(false)}
                    >
                        Cancel
                    </TextButton>
                    {/* <button
                        className="quick-search__clear"
                        onClick={handleCancelSearch}
                        onFocus={() => setFocused(true)}
                        onBlur={() => setFocused(false)}
                    >
                        Cancel
                    </button> */}
                </div>
            ) : null}
        </div>
    );
};

export default QuickSearch;
